<template>
  <div class="modal fade" id="tokenRefreshModal" tabindex="-1" aria-labelledby="tokenRefreshModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="clientModalLabel">Токен</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div class="p-8 rounded border text-center text-gray-400" :style="'border-color: '+token.color.main+'!important'">
            Токен закончиться через:
            <div class="fs-2x fw-bold" :style="'color: '+token.color.main+''">
              {{ token.sec < 0 ? 0 : h+'ч '+m+'м '+s+'с ' }}
            </div>
            Выдано
            {{ new Date(token.countDownDate).toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' }) }}
            в <b>{{ gatedTokenTime }}</b>
          </div>
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button
              @click="logout"
              type="button"
              class="btn btn-sm btn-light-danger"
          >Выйти из системы</button>
          <button
              @click="refresh"
              type="button"
              class="btn btn-sm btn-primary"
          >Обновить токен
          </button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderFull from '@/components/Main/LoaderFull';
import crypto     from '@/helpers/crypto';
import axios      from 'axios';

export default {
  name: 'TokenRefreshModal',
  components: {LoaderFull},
  computed: {
    gatedTokenTime() {
      const date = new Date(this.token.countDownDate)
      const h    = date.getHours()-3
      const m    = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      return h+':'+m
    }
  },
  data () {
    return {
      loader: false,
      s: 0,
      m: 0,
      h: 0,
    }
  },
  props: {
    token: {
      type: Object,
      default: null
    }
  },
  methods: {
    refresh() {
      const headers = { "apc": this.$user.apc ?? null };
      axios.get('/api/refresh', { headers })
          .then(res => {
            if (res.data.access_token) {
              localStorage.setItem('user', crypto.encrypt(JSON.stringify(res.data.user)))
              localStorage.setItem('ttl', res.data.ttl)
              localStorage.setItem('ttlDate', res.data.ttlDate)
              localStorage.setItem('access', crypto.encrypt(res.data.access_token))
              this.$store.dispatch("userRequest", res.data.user);
              location.reload()
            }
          })
          .catch(err => {
            console.log(err.message)
          })
    },
    logout() {
      localStorage.removeItem('access')
      localStorage.removeItem('ttl')
      localStorage.removeItem('user')
      localStorage.removeItem('ttlDate')
      window.location.href = '/login'
    },
  },
  watch: {
    'token.sec': {
      deep: true,
      handler (newValue) {
        if (newValue) {
          this.s = (this.token.sec % 60).toString();
          this.m = Math.floor(this.token.sec / 60 % 60).toString();
          this.h = Math.floor(this.token.sec / 60 / 60 % 60).toString();
        }
      }
    }
  }
}
</script>

<style scoped>
</style>